import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import getWorkingDuration from 'components/ScheduleCalendar/getWorkingDuration';
import { PreviewScheduleRange } from '../convertScheduleRanges';

interface ScheduleSummaryProps {
  scheduleRanges: PreviewScheduleRange[];
  assignedEmployeesCount: number;
}

export default function ScheduleSummary({
  scheduleRanges,
  assignedEmployeesCount,
}: ScheduleSummaryProps) {
  const { t } = useTranslation();

  const workingSeconds = scheduleRanges.reduce(
    (acc, scheduleRange) =>
      acc + (scheduleRange.timeTo - scheduleRange.timeFrom),
    0,
  );

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      p={3}
      sx={{
        '& .MuiTypography-root': {
          userSelect: 'none',
        },
      }}
    >
      <Stack>
        <Typography variant="caption" color="text.secondary">
          {t('label.working_hours')}
        </Typography>
        <Typography variant="h6">{getWorkingDuration(workingSeconds)}</Typography>
      </Stack>
      <Stack>
        <Typography variant="caption" color="text.secondary">
          {t('label.assigned_employees')}
        </Typography>
        <Typography variant="h6" color="text.secondary">
          {assignedEmployeesCount}
        </Typography>
      </Stack>
    </Stack>
  );
}
